import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import spinner from "../assign-prescriptions/images/spinner.gif";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import TextField from "@mui/material/TextField";
import moment from "moment-timezone";
import { withTranslation } from "react-i18next";
import userroles from "../common/userroles";
import { writeAuditLog } from "../common/apis";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  getActionsColumn,
  actionMenuItem,
} from "../grid/iLocalAGGrid";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    padding: "8px 10px",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  button: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  add: {
    "&:hover": {
      backgroundColor: "#6cca98",
      color: "#fff",
    },
  },
});

let FilterObj = {
  searchtext: "",
  fromdate: "",
  todate: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "releasing_history",
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "created_on",
      isDataEmpty: true,
      loader: false,
      title: "",
      description: "",
      isReloadRequire: false,
      isButtonDisabled: false,
      userData: [],
      totalRecords: 0,
      announcementview: true,
      announcementadd: true,
      announcementdelete: true,
      selectedIds: new Set(),
      isDeleting: false,
      confirmOpen: false,
      confirmIds: [],
      createModalOpen: false,
      viewModalOpen: false,
      editModalOpen: false,
      selectedAnnouncement: null,
      editTitle: "",
      editDescription: "",
      editIsReloadRequire: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
          .tz(zone.substring(zone.lastIndexOf(" ") + 1))
          .format("MM/DD/YYYY hh:mm:ss A")
      : date
          .tz(zone.substring(zone.lastIndexOf(" ") + 1))
          .format("DD/MM/YYYY hh:mm:ss A");
  };

  getRowId = (params) => {
    const d = params.data || {};
    if (d.__ssrmId) return String(d.__ssrmId);
    return String(d.id || `row-${Math.random().toString(36).slice(2)}`);
  };

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  BindReleaseHistory = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && FilterObj.pageSize !== newPageSize) {
      FilterObj.pageSize = newPageSize;
    }
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    const selectedNodes = params.api.getSelectedNodes() || [];
    this.setState({
      selectedIds: new Set(
        selectedNodes.map((n) => n.data && n.data.id).filter(Boolean)
      ),
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this._agFilterBody = FilterObj;
    const datasource = createServerSideDatasource({
      filterBody: FilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, {
          dateColIds: ["created_on"],
        });
      },
      sortMap: {
        name: { tableName: "users", sortColumn: "name" },
        title: { tableName: "releasing_history", sortColumn: "title" },
        description: {
          tableName: "releasing_history",
          sortColumn: "description",
        },
        is_reload_require: {
          tableName: "releasing_history",
          sortColumn: "is_reload_require",
        },
        created_on: {
          tableName: "releasing_history",
          sortColumn: "created_on",
        },
      },
      pageZeroBased: true,
      getPageSize: () => FilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(
          process.env.REACT_APP_BASEURL +
            "releasing/history/getAllReleasingHistory",
          {
            method: "POST",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...body,
              searchtext: body.searchtext || "",
              fromdate: body.fromdate || "",
              todate: body.todate || "",
            }),
          }
        ).then((r) => r.json()),
      onSuccess: (results, total) => {
        setTimeout(() => {
          this.setState({
            userData: results,
            totalRecords: total,
            loader: false,
            isDataEmpty: !results || results.length === 0,
            selectedIds: new Set(),
          });
        }, 0);
      },
      onError: () => this.setState({ loader: false }),
    });
    if (typeof params.api.setServerSideDatasource === "function") {
      params.api.setServerSideDatasource(datasource);
    }
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const row = params && params.data;
    if (!row) return;
    this.setState({ selectedAnnouncement: row, selectedRowId: row.id }, () => {
      const items = this.getContextMenuItems({
        ...params,
        column: params.column,
        node: params.node,
        value: params.value,
      });
      if (menuHelpers && typeof menuHelpers.openMenu === "function") {
        menuHelpers.openMenu(items);
      }
    });
  };

  getContextMenuItems = (params) => {
    const colId =
      params &&
      params.column &&
      (params.column.getColId
        ? params.column.getColId()
        : params.column.colId);
    if (colId !== "actions") return [];
    if (!(params.node && params.node.data)) return [];
    const { announcementadd, announcementdelete, isDeleting } = this.state;
    const items = [
      actionMenuItem({
        name: "View",
        icon: "view",
        action: () =>
          this.handleViewAnnouncement(params.node.data),
      }),
    ];
    if (announcementadd) {
      items.push(
        actionMenuItem({
          name: "Edit",
          icon: "edit",
          action: () =>
            this.handleEditAnnouncement(params.node.data),
        })
      );
    }
    if (announcementdelete) {
      items.push(
        actionMenuItem({
          name: "Delete",
          icon: "delete",
          disabled: isDeleting,
          action: () => this.handleDeleteSingle(params.node.data.id),
        })
      );
    }
    return items;
  };

  handleDeleteSingle = (id) => {
    this.setState({ confirmOpen: true, confirmIds: [id] });
  };

  handleBulkDelete = () => {
    const ids = Array.from(this.state.selectedIds);
    if (ids.length === 0) {
      toast.warn(this.props.t("Announcement.NoSelection"));
      return;
    }
    this.setState({ confirmOpen: true, confirmIds: ids });
  };

  handleConfirmClose = () => {
    this.setState({ confirmOpen: false, confirmIds: [] });
  };

  handleConfirmDelete = async () => {
    const { confirmIds } = this.state;
    this.setState({ isDeleting: true });
    try {
      if (confirmIds.length === 1) {
        const id = confirmIds[0];
        const res = await fetch(
          `${process.env.REACT_APP_BASEURL}releasing/history/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
            },
          }
        );
        const data = await res.json();
        if (res.ok && data && data.success) {
          toast.success(this.props.t("Announcement.Deleted"));
          const announcement =
            this.state.userData &&
            this.state.userData.find((a) => a.id === id);
          const announcementTitle =
            (announcement && announcement.title) || "Unknown";
          writeAuditLog(
            `Announcement '${announcementTitle}' deleted.`,
            "Manage Announcement"
          );
          this.BindReleaseHistory();
        } else {
          toast.error((data && data.message) || "Failed");
        }
      } else {
        const res = await fetch(
          `${process.env.REACT_APP_BASEURL}releasing/history/bulk-delete`,
          {
            method: "POST",
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ids: confirmIds }),
          }
        );
        const data = await res.json();
        if (res.ok && data && data.success) {
          toast.success(this.props.t("Announcement.Deleted"));
          const deletedCount = data.deletedCount || confirmIds.length;
          writeAuditLog(
            `${deletedCount} announcement(s) deleted in bulk operation.`,
            "Manage Announcement"
          );
          this.BindReleaseHistory();
        } else {
          toast.error((data && data.message) || "Failed");
        }
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      this.setState({ isDeleting: false, confirmOpen: false, confirmIds: [] });
    }
  };

  handleViewAnnouncement = (announcement) => {
    this.setState({
      viewModalOpen: true,
      selectedAnnouncement: announcement,
    });
  };

  handleEditAnnouncement = (announcement) => {
    this.setState({
      editModalOpen: true,
      selectedAnnouncement: announcement,
      editTitle: announcement.title,
      editDescription: announcement.description,
      editIsReloadRequire: announcement.is_reload_require,
    });
  };

  handleCloseViewModal = () => {
    this.setState({ viewModalOpen: false, selectedAnnouncement: null });
  };

  handleCloseEditModal = () => {
    this.setState({
      editModalOpen: false,
      selectedAnnouncement: null,
      editTitle: "",
      editDescription: "",
      editIsReloadRequire: false,
    });
  };

  handleEditChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      this.setState({ [name]: checked });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleUpdateAnnouncement = async () => {
    const {
      selectedAnnouncement,
      editTitle,
      editDescription,
      editIsReloadRequire,
    } = this.state;

    if (!editTitle.trim() || !editDescription.trim()) {
      toast.error("Title and description are required");
      return;
    }

    this.setState({ isDeleting: true });
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}releasing/history/${selectedAnnouncement.id}`,
        {
          method: "PUT",
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: editTitle,
            description: editDescription,
            isReloadRequire: editIsReloadRequire,
          }),
        }
      );
      const data = await res.json();
      if (res.ok && data && data.success) {
        toast.success("Announcement updated successfully");
        writeAuditLog(
          `Announcement '${editTitle}' updated.`,
          "Manage Announcement"
        );
        this.BindReleaseHistory();
        this.handleCloseEditModal();
      } else {
        toast.error((data && data.message) || "Failed to update");
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      this.setState({ isDeleting: false });
    }
  };

  componentDidMount = () => {
    FilterObj.searchtext = "";
    FilterObj.fromdate = "";
    FilterObj.todate = "";
    FilterObj.pageNo = 0;
    FilterObj.pageSize = 10;
    FilterObj.sortOrder = "desc";
    FilterObj.sortColumn = "created_on";
    FilterObj.tableName = "releasing_history";
    this.setPermissions();
  };

  handleChange = (event) => {
    event.preventDefault();
    const value = event && event.target.name;
    switch (value) {
      case "title":
        this.setState({ title: event.target.value });
        break;
      case "description":
        this.setState({ description: event.target.value });
        break;
      default:
        break;
    }
  };

  handleChangeReloadRequired = (event) => {
    this.setState({ isReloadRequire: event.target.checked });
  };

  handleOpenCreateModal = () => {
    this.setState({
      createModalOpen: true,
      title: "",
      description: "",
      isReloadRequire: false,
      isButtonDisabled: false,
    });
  };

  handleCloseCreateModal = () => {
    this.setState({
      createModalOpen: false,
      title: "",
      description: "",
      isReloadRequire: false,
      isButtonDisabled: false,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const createdTitle = this.state.title;
    this.setState({ loader: true, isButtonDisabled: true });
    const popUpNofifictionObj = {
      title: this.state.title,
      description: this.state.description,
      isReloadRequire: this.state.isReloadRequire,
      parent_account_id: sessionStorage.getItem("parentAccountId"),
    };
    fetch(process.env.REACT_APP_BASEURL + "releasing/history", {
      method: "POST",
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(popUpNofifictionObj),
    })
      .then((response) => response.json())
      .then(async (response) => {
        this.setState({
          title: "",
          description: "",
          isReloadRequire: false,
          loader: false,
          isButtonDisabled: false,
          createModalOpen: false,
        });
        toast.success(response.message);
        writeAuditLog(
          `Announcement '${createdTitle}' created.`,
          "Manage Announcement"
        );
        this.BindReleaseHistory();
      })
      .catch((error) => {
        this.setState({
          loader: false,
          isButtonDisabled: false,
        });
        toast.error(error.message);
      });
  };

  setPermissions = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if (_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ announcementadd: true });
    } else {
      if (permissions && permissions.length > 0) {
        const _manageAnnouncement = permissions.filter((item) => {
          return item.permission_entity_type === "Manage Announcement";
        });
        if (_manageAnnouncement.length > 0) {
          this.setState({
            announcementadd: _manageAnnouncement.some(
              (x) => x.name.trim() === "Add" && x.is_allowed === 1
            ),
          });
        } else {
          this.setState({ announcementadd: false });
        }
      } else {
        this.setState({ announcementadd: false });
      }
    }
  };

  render() {
    const { classes, t } = this.props;
    const {
      announcementadd,
      announcementdelete,
      selectedIds,
      isDeleting,
    } = this.state;

    return (
      <Paper className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}

        <div className={classes.tableWrapper}>
          <div className={classes.toolbar}>
            {announcementdelete && selectedIds.size > 0 && (
              <Button
                onClick={this.handleBulkDelete}
                disabled={isDeleting || selectedIds.size === 0}
                color="primary"
                className={classes.button}
                sx={{ minWidth: "140px" }}
              >
                Delete Selected
              </Button>
            )}
            {announcementadd && (
              <Tooltip title="Add">
                <IconButton
                  aria-label="Add announcement"
                  className={classes.add}
                  onClick={this.handleOpenCreateModal}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
          <ILocalAGGrid
            columnDefs={[
              {
                field: "name",
                headerName: t("Announcement.Name"),
                minWidth: 160,
              },
              {
                field: "title",
                headerName: t("Announcement.Title"),
                minWidth: 180,
              },
              {
                field: "description",
                headerName: t("Announcement.Description"),
                minWidth: 220,
                flex: 1,
              },
              {
                field: "is_reload_require",
                headerName: t("Announcement.ReloadRequired"),
                minWidth: 140,
                filter: false,
                valueFormatter: (p) =>
                  p.value === true ? t("True") : t("False"),
              },
              withDateColumnFilter({
                field: "created_on",
                colId: "created_on",
                headerName: t("Announcement.Date"),
                minWidth: 180,
                valueFormatter: (p) =>
                  p.value ? this.convertToTimeZone(p.value) : "",
              }),
              getActionsColumn({
                headerName: "Actions",
                onActionsClick: (event, params, menuHelpers) =>
                  this.openRowActionsMenu(event, params, menuHelpers),
              }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowSelection="multiple"
            rowModelType="serverSide"
            cacheBlockSize={FilterObj.pageSize || 10}
            paginationPageSize={FilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={45}
            getRowId={this.getRowId}
            onGridReady={this.onGridReady}
            onRowSelected={this.onRowSelected}
            onPaginationChanged={this.onPaginationChanged}
            getContextMenuItems={this.getContextMenuItems}
          />
        </div>

        <Dialog
          open={this.state.createModalOpen}
          onClose={this.handleCloseCreateModal}
          maxWidth="sm"
          fullWidth
        >
          <ValidatorForm onSubmit={this.handleSubmit}>
            <DialogTitle>Create Announcement</DialogTitle>
            <DialogContent>
              <div style={{ marginTop: "8px" }}>
                <TextValidator
                  margin="normal"
                  id="title"
                  name="title"
                  value={this.state.title}
                  label={t("Announcement.TitleTextField")}
                  fullWidth
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={[t("Announcement.EnterTitle")]}
                  variant="standard"
                  autoFocus
                />
                <TextValidator
                  margin="normal"
                  name="description"
                  value={this.state.description}
                  label={t("Announcement.DescriptionTextField")}
                  fullWidth
                  multiline
                  rows={3}
                  onChange={this.handleChange}
                  validators={["required"]}
                  errorMessages={[t("Announcement.EnterDescription")]}
                  variant="standard"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "16px",
                    marginBottom: "8px",
                    fontSize: "0.875rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>
                    {t("Announcement.ReloadRequiredToggle")}
                  </span>
                  <Switch
                    checked={this.state.isReloadRequire}
                    onChange={this.handleChangeReloadRequired}
                    color="primary"
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseCreateModal}
                color="primary"
                disabled={this.state.isButtonDisabled}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                disabled={this.state.isButtonDisabled}
                sx={{ minWidth: "100px" }}
              >
                {t("Announcement.Save")}
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>

        <Dialog
          open={this.state.confirmOpen}
          onClose={this.handleConfirmClose}
          aria-labelledby="confirm-dialog-title"
        >
          <DialogTitle id="confirm-dialog-title">
            Delete announcement(s)?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              This action cannot be undone. Do you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleConfirmClose}
              color="primary"
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleConfirmDelete}
              color="primary"
              className={classes.button}
              disabled={isDeleting}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.viewModalOpen}
          onClose={this.handleCloseViewModal}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Announcement Details</DialogTitle>
          <DialogContent>
            {this.state.selectedAnnouncement && (
              <div>
                <div style={{ marginBottom: "16px" }}>
                  <strong>Title:</strong>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.selectedAnnouncement.title}
                  </div>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <strong>Description:</strong>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.selectedAnnouncement.description}
                  </div>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <strong>Reload Required:</strong>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.selectedAnnouncement.is_reload_require
                      ? "Yes"
                      : "No"}
                  </div>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <strong>Created By:</strong>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.selectedAnnouncement.name}
                  </div>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <strong>Created On:</strong>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.selectedAnnouncement.created_on
                      ? this.convertToTimeZone(
                          this.state.selectedAnnouncement.created_on
                        )
                      : ""}
                  </div>
                </div>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseViewModal} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.editModalOpen}
          onClose={this.handleCloseEditModal}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Edit Announcement</DialogTitle>
          <DialogContent>
            <div style={{ marginTop: "16px" }}>
              <TextField
                name="editTitle"
                value={this.state.editTitle}
                label="Title"
                fullWidth
                onChange={this.handleEditChange}
                variant="standard"
                required
                style={{ marginBottom: "16px" }}
              />
              <TextField
                name="editDescription"
                value={this.state.editDescription}
                label="Description"
                fullWidth
                multiline
                rows={4}
                onChange={this.handleEditChange}
                variant="standard"
                required
                style={{ marginBottom: "16px" }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <span style={{ marginRight: "8px" }}>Reload Required</span>
                <Switch
                  name="editIsReloadRequire"
                  checked={this.state.editIsReloadRequire}
                  onChange={this.handleEditChange}
                  color="primary"
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseEditModal}
              color="primary"
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleUpdateAnnouncement}
              color="primary"
              className={classes.button}
              disabled={isDeleting}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/releaseHistory/index.js